import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

export default function HammurabiContract() {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="bg-zinc-950 border border-fuchsia-500/30 rounded-lg overflow-hidden font-mono text-xs shadow-[0_0_30px_rgba(217,70,239,0.05)]"
    >
      <div className="flex items-center justify-between px-4 py-3 border-b border-zinc-800 bg-zinc-900/80">
        <div className="flex items-center gap-2">
          <SafeIcon icon={FiIcons.FiShield} className="text-fuchsia-400" />
          <span className="text-zinc-400 tracking-widest uppercase">hammurabi_escrow.rs</span>
        </div>
        <div className="px-2 py-0.5 rounded bg-fuchsia-500/10 border border-fuchsia-500/30 text-[9px] text-fuchsia-400 tracking-widest uppercase">
          Rule 5: Cryptographic Handoff
        </div>
      </div>

      <div className="p-6 overflow-x-auto text-[11px] md:text-xs leading-relaxed whitespace-pre">
        <span className="text-zinc-600">{"// BSM-C LIVING REGISTRY: THE HAMMURABI HANDOFF"}</span>
        <br />
        <span className="text-zinc-600">{"// Enforcing strict accountability for corporate data settlement."}</span>
        <br /><br />

        <span className="text-amber-400">#[program]</span>
        <br />
        <span className="text-fuchsia-400">pub mod</span> <span className="text-zinc-100">hammurabi_escrow</span> {"{"}
        <br />
        {"    "}<span className="text-fuchsia-400">use</span> <span className="text-zinc-300">super::*;</span>
        <br /><br />

        {"    "}<span className="text-fuchsia-400">pub fn</span> <span className="text-cyan-400">execute_handoff</span>{"("}
        <br />
        {"        "}<span className="text-zinc-400">ctx:</span> <span className="text-amber-400">Context</span>{"<HammurabiHandoff>,"}
        <br />
        {"        "}<span className="text-zinc-400">medallion_id:</span> {"[u8; 32],"}
        <br />
        {"        "}<span className="text-zinc-400">data_quality_score:</span> <span className="text-emerald-400">u8</span>{","}
        <br />
        {"        "}<span className="text-zinc-400">corporate_bounty:</span> <span className="text-emerald-400">u64</span>{","}
        <br />
        {"    ) -> "} <span className="text-amber-400">Result</span>{"<()> {"}
        <br /><br />

        {"        "}<span className="text-zinc-600">{"// RULE 2: Verify Doppelganger Sandbox signature (Zero-PII guarantee)"}</span>
        <br />
        {"        "}<span className="text-cyan-400">require!</span>{"("}
        <br />
        {"            ctx.accounts.sandbox."}<span className="text-cyan-400">verify_pii_stripped</span>{"()?,"}
        <br />
        {"            BsmcError::PiiLeakDetected"}
        <br />
        {"        );"}
        <br /><br />

        {"        "}<span className="text-zinc-600">{"// RULE 5: Cryptographic consent binding (Operator Signature)"}</span>
        <br />
        {"        "}<span className="text-cyan-400">require!</span>{"("}
        <br />
        {"            ctx.accounts.user."}<span className="text-cyan-400">verify_ed25519_signature</span>{"()?,"}
        <br />
        {"            BsmcError::InvalidConsent"}
        <br />
        {"        );"}
        <br /><br />

        {"        "}<span className="text-zinc-600">{"// ESCROW: Lock differential privacy payload in Eduba Cache"}</span>
        <br />
        {"        ctx.accounts.eduba_cache."}<span className="text-cyan-400">lock_payload</span>{"(medallion_id)?;"}
        <br /><br />

        {"        "}<span className="text-zinc-600">{"// SETTLEMENT: Release fiat-backed stablecoin to Sovereign Node"}</span>
        <br />
        {"        token::"}<span className="text-cyan-400">transfer</span>{"("}
        <br />
        {"            ctx.accounts.corporate_vault,"}
        <br />
        {"            ctx.accounts.user_wallet,"}
        <br />
        {"            corporate_bounty"}
        <br />
        {"        )?;"}
        <br /><br />

        {"        "}<span className="text-cyan-400">emit!</span>{"(HandoffComplete {"}
        <br />
        {"            medallion_id,"}
        <br />
        {"            bounty: corporate_bounty,"}
        <br />
        {"            quality: data_quality_score"}
        <br />
        {"        });"}
        <br /><br />

        {"        "}<span className="text-amber-400">Ok</span>{"(())"}
        <br />
        {"    }"}
        <br />
        {"}"}
      </div>
      
      <div className="bg-fuchsia-500/10 border-t border-fuchsia-500/30 p-4 flex items-start gap-3">
        <SafeIcon icon={FiIcons.FiInfo} className="text-fuchsia-400 mt-0.5 flex-shrink-0" />
        <p className="text-[10px] text-zinc-400 font-sans leading-relaxed">
          The <span className="text-zinc-200 font-bold">Hammurabi Escrow</span> guarantees that enterprise capital is only released when the sovereign node provides cryptographic proof that the data is both high-fidelity and fully sanitized of PII. <span className="text-fuchsia-400">No middlemen. Trustless settlement.</span>
        </p>
      </div>
    </motion.div>
  );
}